import { render, staticRenderFns } from "./Entries.vue?vue&type=template&id=2584db10&scoped=true&"
import script from "./Entries.vue?vue&type=script&lang=ts&"
export * from "./Entries.vue?vue&type=script&lang=ts&"
import style0 from "./Entries.vue?vue&type=style&index=0&id=2584db10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584db10",
  null
  
)

export default component.exports